<template>

  <div v-if="editMode || filled">
    <div class="card-header">
      <i
        class="fas fa-pencil-alt"
        :title="$t('Edit')"
        v-if="!editable && editMode"
        @click.stop="editSection(true)"
        style="cursor: pointer; float: right;">
        </i>
      <strong>{{ $t('Resume (file)') }}</strong>
    </div>
    <div
      v-if="editable"
      class="card-body">
      <div
        class="form-group"
        :class="{'box-loading': loading}">
        <input-drop-media
          @input="uploadFile"
          :multiple="false">
          </input-drop-media>
        <ValidateMessage :error="validateErrors.resume_media_id" />
      </div>
      <div>
        <button
          type="button"
          class="btn btn-danger"
          @click.stop="removeFile"
          v-if="candidateEdit.resume_media_id">{{ $t('Remove') }}</button>
        <button
          type="button"
          class="btn btn-light"
          @click.stop="editSection(false)">{{ $t('Cancel') }}</button>
      </div>
    </div>
    <div v-if="!editable && filled">
      <div class="card-body">
        <a
          style="float: right;"
          target="_blank"
          :href="pdfViewer" 
          class="btn btn-sm btn-light">
          <i class="fas fa-external-link-alt" />
          </a>
        <CandidateProfileResumeParse />
      </div>

      <iframe
        v-resize="{ log: false }"
        :src="pdfViewer"
        style="border: 0; width: 100%; min-height: 300px; height: 2000px;" />

      <!--<iframe
        :src="`https://mozilla.github.io/pdf.js/web/viewer.html?file=${encodeURIComponent(pdfConverUrl)}`"
        style="border:0; width:100%; height:5000px;" />-->

      <!--<iframe
        ref="frame"
        :src="'//docs.google.com/gview?embedded=true&url=' + candidate.resume_media_id.url"
        style="border:0; width:100%; height:7000px;"
        scrolling="no" />-->
    </div>
  </div>

</template>

<script>
import _ from 'lodash'
import config from '@/config'
import CandidateProfileResumeParse from './CandidateProfileResumeParse'
import InputDropMedia from '@/components/Fields/InputDropMedia'

export default {
  name: 'CandidateProfileCoverLetter',
  components: {
    CandidateProfileResumeParse,
    InputDropMedia
  },
  props: [
    'editMode'
  ],
  data () {
    return {
      loading: false,
      sectionEdit: false,
      candidateEdit: {},
      validateErrors: false
    }
  },
  computed: {
    pdfConverUrl () {
      return `${config.doconvert_url}pdf-convert?url=${this.candidate.resume_media_id.url}`
    },
    pdfViewer () {
      return `https://quickin-pdfviewer.s3-sa-east-1.amazonaws.com/generic/web/viewer.html?file=${encodeURIComponent(this.pdfConverUrl)}`
    },
    editable () {
      return this.sectionEdit && this.editMode
    },
    candidate () {
      return this.$store.getters.getCandidate
    },
    filled () {
      return this.candidate.resume_media_id
    }
  },
  methods: {
    editSection (status) {
      this.sectionEdit = status
      this.candidateEdit = _.pick(this.candidate, [
        '_id',
        'resume_media_id'
      ])
    },
    save (data) {
      this.loading = true

      this.$store.dispatch('updateCandidate', data)
      .then((response) => {
        this.loading = false
        this.sectionEdit = false
      })
      .catch((err) => {
        this.loading = false
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
      })
    },
    uploadFile (medias) {
      this.candidateEdit.resume_media_id = medias[0]
      this.save(this.candidateEdit)
    },
    removeFile (data) {
      this.candidateEdit.resume_media_id = null
      this.save(this.candidateEdit)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Candidate/Profile/CandidateProfileResume.vue